module.exports = __webpack_public_path__ + "media/images/redesign-images/collabs/collabs-logos/gildan-240c63ba8cbe21e744d6d42565851ac6.svg";